import Toasted from 'vue-toasted';
import Vue from 'vue';
import {COMMON_TOAST_DELAY} from '../config/common-constants';
import {AxiosRequestConfig, AxiosResponse, AxiosError} from 'axios';
import {APIBaseService} from './api.service.base';
import {useRouter} from '@/router';
import {RouterAliases} from '@/router/routerAliases';
import {logout} from './auth-shared';

Vue.use(Toasted);

export const domainUrl = process.env.VUE_APP_BASE_API_URL;
export const baseURL = `${domainUrl}/v2/`;

export function showErrorToast(message = 'We could not complete your action at the moment. Please try again') {
  Vue.toasted.show(message, {
    position: 'top-right',
    className: 'toast-error',
    duration: COMMON_TOAST_DELAY,
    action: {
      text: 'CLOSE',
      onClick: (event, toastObject) => {
        toastObject.goAway(0);
      },
    },
    singleton: true,
  });
}

function handleResponse<T>(promise: Promise<AxiosResponse<T>>, suspendError: boolean, suspendLogout = false) {
  return promise
    .then((response) => response.data)
    .catch((e: AxiosError) => {
      if (suspendLogout && e.response?.status === 401) {
        return Promise.reject(e.response);
      }
      if (e.response?.status === 401 && process.env.VUE_APP_AUTH0_ENABLED) {
        logout();
        const router = useRouter();
        router.replace({name: RouterAliases.DISCOVERY_VIEW});
        return Promise.reject(e.response);
      }

      if (e.response?.status === 401 && process.env.VUE_APP_AMEX_AUTH_ENABLED) {
        logout();
        const router = useRouter();
        router.replace({name: RouterAliases.AMEX_LANDING});
        return Promise.reject(e.response);
      }

      if (!suspendError) {
        showErrorToast();
      }
      return Promise.reject(e.response);
    });
}

export const APIService = {
  get<T>(
    path: string,
    options?: Readonly<AxiosRequestConfig>,
    suspendError = false,
    suspendLogout = false,
  ): Promise<T> {
    return handleResponse(APIBaseService.get(path, options), suspendError, suspendLogout);
  },
  delete<T>(path: string, options?: Readonly<AxiosRequestConfig>, suspendError = false): Promise<T> {
    return handleResponse(APIBaseService.delete(path, options), suspendError);
  },
  post<T>(
    path: string,
    data?: Readonly<unknown>,
    options?: Readonly<AxiosRequestConfig>,
    suspendError = false,
  ): Promise<T> {
    return handleResponse(APIBaseService.post(path, data, options), suspendError);
  },
};
